// German translations for React Admin
// Based on ra-language-german but inline to avoid dependency issues

const germanMessages = {
    ra: {
        action: {
            add_filter: 'Filter hinzufügen',
            add: 'Hinzufügen',
            back: 'Zurück',
            bulk_actions: '%{smart_count} ausgewählt',
            cancel: 'Abbrechen',
            clear_array_input: 'Liste löschen',
            clear_input_value: 'Wert löschen',
            clone: 'Duplizieren',
            confirm: 'Bestätigen',
            create: 'Anlegen',
            create_item: '%{item} anlegen',
            delete: 'Löschen',
            edit: 'Bearbeiten',
            export: 'Exportieren',
            list: 'Liste',
            refresh: 'Aktualisieren',
            remove_filter: 'Filter entfernen',
            remove_all_filters: 'Alle Filter entfernen',
            remove: 'Entfernen',
            save: 'Speichern',
            search: 'Suchen',
            select_all: 'Alle auswählen',
            select_row: 'Zeile auswählen',
            show: 'Anzeigen',
            sort: 'Sortieren',
            undo: 'Rückgängig',
            unselect: 'Abwählen',
            expand: 'Erweitern',
            close: 'Schließen',
            open_menu: 'Menü öffnen',
            close_menu: 'Menü schließen',
            update: 'Aktualisieren',
            move_up: 'Nach oben',
            move_down: 'Nach unten',
            open: 'Öffnen',
            toggle_theme: 'Theme umschalten',
            select_columns: 'Spalten',
            reset: 'Zurücksetzen',
            search_columns: 'Spalten durchsuchen',
            select_all_button: 'Alle auswählen',
            update_application: 'Anwendung neu laden',
        },
        boolean: {
            true: 'Ja',
            false: 'Nein',
            null: ' ',
        },
        page: {
            create: '%{name} anlegen',
            dashboard: 'Dashboard',
            edit: '%{name} #%{id}',
            error: 'Ein Fehler ist aufgetreten',
            list: '%{name}',
            loading: 'Lade',
            not_found: 'Nicht gefunden',
            show: '%{name} #%{id}',
            empty: 'Noch keine %{name}.',
            invite: 'Möchten Sie eine anlegen?',
        },
        input: {
            file: {
                upload_several:
                    'Dateien zum Hochladen hier ablegen oder klicken zum Auswählen.',
                upload_single:
                    'Datei zum Hochladen hier ablegen oder klicken zum Auswählen.',
            },
            image: {
                upload_several:
                    'Bilder zum Hochladen hier ablegen oder klicken zum Auswählen.',
                upload_single:
                    'Bild zum Hochladen hier ablegen oder klicken zum Auswählen.',
            },
            references: {
                all_missing: 'Die verknüpften Daten konnten nicht gefunden werden.',
                many_missing:
                    'Mindestens eine der verknüpften Daten ist nicht mehr verfügbar.',
                single_missing:
                    'Die verknüpften Daten sind nicht mehr verfügbar.',
            },
            password: {
                toggle_visible: 'Passwort verbergen',
                toggle_hidden: 'Passwort anzeigen',
            },
        },
        message: {
            about: 'Über',
            are_you_sure: 'Sind Sie sicher?',
            bulk_delete_content:
                'Sind Sie sicher, dass Sie %{name} löschen möchten? |||| Sind Sie sicher, dass Sie diese %{smart_count} Elemente löschen möchten?',
            bulk_delete_title:
                '%{name} löschen |||| %{smart_count} %{name} löschen',
            bulk_update_content:
                'Sind Sie sicher, dass Sie %{name} aktualisieren möchten? |||| Sind Sie sicher, dass Sie diese %{smart_count} Elemente aktualisieren möchten?',
            bulk_update_title:
                '%{name} aktualisieren |||| %{smart_count} %{name} aktualisieren',
            delete_content: 'Sind Sie sicher, dass Sie dieses Element löschen möchten?',
            delete_title: '%{name} #%{id} löschen',
            details: 'Details',
            error:
                'Ein Fehler ist aufgetreten und Ihre Anfrage konnte nicht abgeschlossen werden.',
            invalid_form: 'Das Formular ist nicht korrekt. Bitte überprüfen Sie die Fehler',
            loading: 'Die Seite lädt, einen Moment bitte',
            no: 'Nein',
            not_found:
                'Sie haben eine falsche URL eingegeben oder einen fehlerhaften Link angeklickt.',
            yes: 'Ja',
            unsaved_changes:
                'Einige Ihrer Änderungen wurden nicht gespeichert. Sind Sie sicher, dass Sie diese ignorieren möchten?',
        },
        navigation: {
            no_results: 'Keine Ergebnisse gefunden',
            no_more_results:
                'Seite %{page} liegt außerhalb des Seitenbereichs. Versuchen Sie die vorherige Seite.',
            page_out_of_boundaries: 'Seite %{page} liegt außerhalb der Grenzen',
            page_out_from_end: 'Kann nicht über die letzte Seite hinausgehen',
            page_out_from_begin: 'Kann nicht vor Seite 1 gehen',
            page_range_info: '%{offsetBegin}-%{offsetEnd} von %{total}',
            partial_page_range_info:
                '%{offsetBegin}-%{offsetEnd} von mehr als %{offsetEnd}',
            current_page: 'Seite %{page}',
            page: 'Gehe zu Seite %{page}',
            first: 'Gehe zur ersten Seite',
            last: 'Gehe zur letzten Seite',
            next: 'Weiter',
            previous: 'Zurück',
            page_rows_per_page: 'Zeilen pro Seite:',
            skip_nav: 'Zum Inhalt springen',
        },
        sort: {
            sort_by: 'Sortieren nach %{field} %{order}',
            ASC: 'aufsteigend',
            DESC: 'absteigend',
        },
        auth: {
            auth_check_error: 'Bitte melden Sie sich an, um fortzufahren',
            user_menu: 'Profil',
            username: 'Benutzername',
            password: 'Passwort',
            sign_in: 'Anmelden',
            sign_in_error: 'Authentifizierung fehlgeschlagen, bitte erneut versuchen',
            logout: 'Abmelden',
        },
        notification: {
            updated:
                'Element erfolgreich aktualisiert |||| %{smart_count} Elemente erfolgreich aktualisiert',
            created: 'Element erfolgreich angelegt',
            deleted:
                'Element erfolgreich gelöscht |||| %{smart_count} Elemente erfolgreich gelöscht',
            bad_item: 'Fehlerhaftes Element',
            item_doesnt_exist: 'Element existiert nicht',
            http_error: 'Serverfehler',
            data_provider_error:
                'dataProvider Fehler. Prüfen Sie die Konsole für Details.',
            i18n_error:
                'Die Übersetzungen für die angegebene Sprache konnten nicht geladen werden',
            canceled: 'Aktion abgebrochen',
            logged_out: 'Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an.',
        },
        validation: {
            required: 'Erforderlich',
            minLength: 'Mindestens %{min} Zeichen',
            maxLength: 'Maximal %{max} Zeichen',
            minValue: 'Mindestens %{min}',
            maxValue: 'Maximal %{max}',
            number: 'Muss eine Zahl sein',
            email: 'Muss eine gültige E-Mail-Adresse sein',
            oneOf: 'Muss einer der folgenden Werte sein: %{options}',
            regex: 'Muss dem Format entsprechen (regexp): %{pattern}',
        },
        saved_queries: {
            label: 'Gespeicherte Abfragen',
            query_name: 'Abfragename',
            new_label: 'Aktuelle Abfrage speichern...',
            new_dialog_title: 'Aktuelle Abfrage speichern als',
            remove_label: 'Gespeicherte Abfrage entfernen',
            remove_label_with_name: 'Abfrage "%{name}" entfernen',
            remove_dialog_title: 'Gespeicherte Abfrage entfernen?',
            remove_message: 'Sind Sie sicher, dass Sie diesen Eintrag aus Ihrer Liste der gespeicherten Abfragen entfernen möchten?',
            help: 'Filter die Liste und speichere diese Abfrage für später',
        },
        configurable: {
            customize: 'Anpassen',
            configureMode: 'Diese Seite konfigurieren',
            inspector: {
                title: 'Inspektor',
                content: 'Bewegen Sie den Mauszeiger über UI-Elemente, um sie zu konfigurieren',
                reset: 'Einstellungen zurücksetzen',
                hideAll: 'Alle ausblenden',
                showAll: 'Alle anzeigen',
            },
            Datagrid: {
                title: 'Datentabelle',
                unlabeled: 'Unbenannte Spalte #%{column}',
            },
            SimpleForm: {
                title: 'Formular',
                unlabeled: 'Unbenanntes Eingabefeld #%{input}',
            },
            SimpleList: {
                title: 'Liste',
                primaryText: 'Primärer Text',
                secondaryText: 'Sekundärer Text',
                tertiaryText: 'Tertiärer Text',
            },
        },
    },
};

export const de = {
    ...germanMessages,
    resources: {
        companies: {
            name: 'Firma |||| Firmen',
            fields: {
                name: 'Name',
                email: 'E-Mail',
                phone: 'Telefon',
                street: 'Straße',
                zip: 'PLZ',
                city: 'Stadt',
                country: 'Land',
                billingStreet: 'Rechnungsstraße',
                billingZip: 'Rechnungs-PLZ',
                billingCity: 'Rechnungsstadt',
                billingCountry: 'Rechnungsland',
                taxId: 'Steuernummer / USt-ID',
                commercialRegister: 'Handelsregisternummer',
                website: 'Webseite',
                active: 'Aktiv',
                createdAt: 'Erstellt am',
                updatedAt: 'Aktualisiert am',
            },
            tabs: {
                general: 'Allgemein',
                address: 'Adresse',
                billing: 'Rechnungsadresse',
                legal: 'Rechtliche Informationen',
            },
        },
        users: {
            name: 'Benutzer |||| Benutzer',
            fields: {
                email: 'E-Mail',
                firstName: 'Vorname',
                lastName: 'Nachname',
                phone: 'Telefon',
                mobile: 'Mobil',
                street: 'Straße',
                zip: 'PLZ',
                city: 'Stadt',
                country: 'Land',
                dateOfBirth: 'Geburtsdatum',
                jobTitle: 'Position',
                department: 'Abteilung',
                language: 'Bevorzugte Sprache',
                company: 'Firma',
                roles: 'Rollen',
                userRoles: 'Rollen',
                password: 'Passwort',
                createdAt: 'Erstellt am',
                updatedAt: 'Aktualisiert am',
            },
            tabs: {
                general: 'Allgemein',
                contact: 'Kontakt & Adresse',
                work: 'Arbeitsinformationen',
                personal: 'Persönlich',
                roles: 'Rollen & Berechtigungen',
            },
        },
        profile: {
            name: 'Profil',
            fields: {
                id: 'ID',
                email: 'E-Mail',
                firstName: 'Vorname',
                lastName: 'Nachname',
                phone: 'Telefon',
                mobile: 'Mobil',
                street: 'Straße',
                zip: 'PLZ',
                city: 'Stadt',
                country: 'Land',
                dateOfBirth: 'Geburtsdatum',
                jobTitle: 'Position',
                department: 'Abteilung',
                language: 'Bevorzugte Sprache',
            },
        },
        invitations: {
            name: 'Einladung |||| Einladungen',
            fields: {
                email: 'E-Mail',
                company: 'Firma',
                roles: 'Rollen',
                token: 'Token',
                createdAt: 'Erstellt am',
                expiresAt: 'Gültig bis',
                used: 'Verwendet',
                usedAt: 'Verwendet am',
                invitedBy: 'Eingeladen von',
                registeredUser: 'Registrierter Benutzer',
            },
        },
        roles: {
            name: 'Rolle |||| Rollen',
            fields: {
                name: 'Name',
                description: 'Beschreibung',
                permissions: 'Berechtigungen',
            },
        },
        permissions: {
            name: 'Berechtigung |||| Berechtigungen',
            fields: {
                name: 'Name',
                description: 'Beschreibung',
            },
        },
        products: {
            name: 'Produkt |||| Produkte',
            fields: {
                name: 'Name',
                description: 'Beschreibung',
                price: 'Preis',
                createdAt: 'Erstellt am',
                updatedAt: 'Aktualisiert am',
            },
        },
        licenses: {
            name: 'Lizenz |||| Lizenzen',
            fields: {
                company: 'Firma',
                product: 'Produkt',
                validFrom: 'Gültig ab',
                validUntil: 'Gültig bis',
                maxUsers: 'Max. Benutzer',
                createdAt: 'Erstellt am',
                updatedAt: 'Aktualisiert am',
            },
        },
    },
    custom: {
        changePassword: 'Passwort ändern',
        currentPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort',
        confirmPassword: 'Passwort bestätigen',
        passwordChanged: 'Passwort erfolgreich geändert',
        language: 'Sprache',
        profile: {
            menuItem: 'Mein Profil',
            emailLocked: 'E-Mail-Adressen können nur von Superadmins geändert werden. Bitte wende dich an den Support.',
            title: 'Mein Profil',
            notLoggedIn: 'Sie sind nicht angemeldet',
        },
    },
    profile: {
        avatar: {
            title: 'Profilbild',
            hint: 'JPG, PNG, GIF oder WebP. Max. 2 MB.',
            remove: 'Bild entfernen',
            uploadSuccess: 'Profilbild erfolgreich hochgeladen',
            uploadError: 'Fehler beim Hochladen des Profilbilds',
            deleteSuccess: 'Profilbild entfernt',
            deleteError: 'Fehler beim Entfernen des Profilbilds',
            invalidType: 'Ungültiges Dateiformat. Erlaubt: JPG, PNG, GIF, WebP',
            tooLarge: 'Datei zu groß. Maximal 2 MB.',
        },
    },
    courseEnrollmentDialog: {
        title: 'Teilnehmer',
        addUser: 'Benutzer einschreiben',
        bulkEnroll: 'Massen-Einschreibung',
        selectUser: 'Benutzer auswählen',
        enroll: 'Einschreiben',
        remove: 'Abmelden',
        enrollSuccess: 'Benutzer erfolgreich eingeschrieben',
        enrollError: 'Fehler beim Einschreiben',
        alreadyEnrolled: 'Dieser Benutzer ist bereits eingeschrieben',
        removeSuccess: 'Teilnehmer erfolgreich abgemeldet',
        removeError: 'Fehler beim Abmelden',
        confirmRemove: 'Möchten Sie diesen Teilnehmer wirklich abmelden?',
        loadError: 'Fehler beim Laden der Teilnehmer',
        noEnrollments: 'Noch keine Teilnehmer eingeschrieben',
        table: {
            name: 'Name',
            email: 'E-Mail',
            status: 'Status',
            progress: 'Fortschritt',
            enrolledAt: 'Eingeschrieben am',
        },
        status: {
            enrolled: 'Eingeschrieben',
            in_progress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            failed: 'Nicht bestanden',
            pending_approval: 'Ausstehend',
            rejected: 'Abgelehnt',
        },
    },
    enrollments: {
        manage: {
            title: 'Einschreibungen verwalten',
            importCsv: 'Import CSV',
            exportCsv: 'Export CSV',
            enrollUser: 'Benutzer einschreiben',
            bulkEnroll: 'Massen-Einschreibung',
            bulkPartial: '%{enrolled} eingeschrieben, %{skipped} übersprungen, %{failed} nicht eingeschrieben: %{reason}',
            bulkCourse: 'Kurs',
            deleteConfirm: 'Einschreibung von %{user} in „%{course}“ löschen? Der Lernfortschritt in diesem Kurs geht dabei verloren. Das lässt sich nicht rückgängig machen.',
            selectCourse: 'Kurs auswählen',
            allCourses: 'Alle Kurse',
            statusFilter: 'Status Filter',
            statusAll: 'Alle',
            statusEnrolled: 'Eingeschrieben',
            statusInProgress: 'In Bearbeitung',
            statusCompleted: 'Abgeschlossen',
            statusFailed: 'Nicht bestanden',
            loading: 'Lade Einschreibungen...',
            noEnrollments: 'Keine Einschreibungen für diesen Kurs gefunden.',
            table: {
                name: 'Name',
                email: 'Email',
                course: 'Kurs',
                status: 'Status',
                progress: 'Fortschritt',
                score: 'Punktzahl',
                enrolled: 'Eingeschrieben',
                started: 'Gestartet',
                completed: 'Abgeschlossen',
                time: 'Zeit',
                actions: 'Aktionen',
            },
            dialog: {
                title: 'Benutzer einschreiben',
                user: 'Benutzer',
                userHelp: 'Wählen Sie einen Benutzer aus dem SSO-System',
                course: 'Kurs',
                enroll: 'Einschreiben',
            },
        },
        dashboard: {
            title: 'Enrollment Dashboard',
            enrollUser: 'Benutzer einschreiben',
            stats: {
                total: 'Gesamt Einschreibungen',
                active: 'Aktive Lernende',
                completed: 'Abgeschlossen',
                avgProgress: 'Ø Fortschritt',
            },
            courseStats: {
                title: 'Kurs-Statistiken',
                noData: 'Keine Kursdaten verfügbar.',
                table: {
                    course: 'Kurs',
                    enrollments: 'Einschreibungen',
                    completionRate: 'Abschlussquote',
                    avgProgress: 'Ø Fortschritt',
                    avgScore: 'Ø Punktzahl',
                },
            },
        },
        csvImport: {
            title: 'CSV Import - Benutzer einschreiben',
            formatInfo: 'CSV-Format: Eine E-Mail-Adresse pro Zeile. Erste Zeile wird als Header übersprungen.',
            course: 'Kurs',
            selectFile: 'CSV-Datei auswählen',
            file: 'Datei',
            import: 'Importieren',
            selectFileAndCourse: 'Bitte wählen Sie eine CSV-Datei und einen Kurs aus',
            userNotFound: 'Benutzer nicht gefunden',
            enrollError: 'Fehler beim Einschreiben',
            importComplete: 'Import abgeschlossen: %{success} erfolgreich, %{failed} fehlgeschlagen',
            processingError: 'Fehler beim Verarbeiten der CSV-Datei',
            results: {
                success: 'Erfolgreich',
                failed: 'Fehlgeschlagen',
                errors: 'Fehler',
            },
        },
    },
    menu: {
        dashboard: 'Dashboard',
        mediaLibrary: 'Medienbibliothek',
        wiki: 'Aktuelles & Wissen',
        courses: 'Kurse',
        courseCatalogs: 'Kursverwaltung',
        courseCatalog: 'Kurskatalog',
        learningPaths: 'Lernpfade',
        achievements: 'Meine Erfolge',
        enrollmentDashboard: 'Enrollment Dashboard',
        manageEnrollments: 'Einschreibungen verwalten',
        enrollments: 'Einschreibungen',
        myCourses: 'Meine Kurse',
        myCertificates: 'Meine Zertifikate',
        bookmarks: 'Meine Lesezeichen',
        analytics: 'Statistiken',
        instructorAnalytics: 'Trainer-Dashboard',
        learningGroups: 'Lerngruppen',
        peerReview: 'Peer-Reviews',
        library: 'Bibliothek',
        notes: 'Meine Notizen',
        certificates: 'Zertifikate',
    },
    dashboard: {
        title: 'Dashboard',
        defaultName: 'Lernende/r',
        welcome: 'Willkommen zurück, %{firstName}!',
        subtitle: 'Ihr Lern- und Wissensportal',
        quickAccess: 'Schnellzugriff',
        pendingReviews: 'Ausstehende Reviews',
        myLearningGroups: 'Meine Lerngruppen',
        stats: {
            myCourses: 'Meine Kurse',
            inProgress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            wikiArticles: 'Aktuelles & Wissen',
            media: 'Medien',
        },
        quickAccessCards: {
            myCourses: {
                title: 'Meine Kurse',
                description: 'Setzen Sie Ihr Lernen fort',
            },
            catalogs: {
                title: 'Kursverwaltung',
                description: 'Kataloge + Kurse anlegen / bearbeiten',
            },
            catalog: {
                title: 'Kurskatalog',
                description: 'Neue Kurse entdecken + buchen',
            },
            wiki: {
                title: 'Aktuelles & Wissen',
                description: 'Artikel und Neuigkeiten durchsuchen',
            },
            media: {
                title: 'Medienbibliothek',
                description: 'Dateien verwalten',
            },
        },
        activities: {
            mostViewed: '📈 Meist gelesene Artikel',
            recentArticles: '🆕 Neueste Artikel',
            recentFiles: '📁 Neueste Dateien',
            noArticles: 'Keine Artikel verfügbar',
            noNewArticles: 'Keine neuen Artikel',
            noFiles: 'Keine Dateien vorhanden',
            views: 'Aufrufe',
            published: 'Veröffentlicht',
            draft: 'Entwurf',
        },
    },
    myCourses: {
        title: 'Meine Kurse',
        loading: 'Lade Kurse...',
        courseNotFound: 'Kurs nicht gefunden',
        enrolled: 'Eingeschrieben',
        learningTime: 'Lernzeit',
        completed: 'Abgeschlossen',
        noEnrollments: 'Sie sind derzeit in keinem Kurs eingeschrieben. Wenden Sie sich an Ihren Administrator, um sich in Kurse einzuschreiben.',
        noCoursesInProgress: 'Keine Kurse in Bearbeitung.',
        allCoursesStarted: 'Alle Kurse wurden bereits gestartet.',
        noCoursesCompleted: 'Noch keine Kurse abgeschlossen.',
        status: {
            completed: 'Abgeschlossen',
            inProgress: 'In Bearbeitung',
            failed: 'Nicht bestanden',
            notStarted: 'Noch nicht begonnen',
            pendingApproval: 'Ausstehend',
            rejected: 'Abgelehnt',
            suspended: 'Pausiert',
        },
        buttons: {
            start: 'Kurs starten',
            continue: 'Fortsetzen',
            review: 'Erneut ansehen',
            retry: 'Erneut versuchen',
        },
        tabs: {
            all: 'Alle (%{count})',
            inProgress: 'In Bearbeitung (%{count})',
            notStarted: 'Noch nicht begonnen (%{count})',
            completed: 'Abgeschlossen (%{count})',
        },
    },
    certificates: {
        title: 'Meine Zertifikate',
        loading: 'Lade Zertifikate...',
        noCertificates: 'Keine Zertifikate vorhanden.',
        search: 'Zertifikate suchen...',
        download: 'Herunterladen',
        shareTooltip: 'Verifizierungslink kopieren',
        linkCopied: 'Link in die Zwischenablage kopiert',
        copyFailed: 'Kopieren fehlgeschlagen',
        issuedAt: 'Ausgestellt am',
        expiresAt: 'Gültig bis',
        score: 'Punktzahl',
        verificationCode: 'Verifizierungscode',
        status: {
            valid: 'Gültig',
            expired: 'Abgelaufen',
            expiringSoon: 'Läuft in %{days} Tagen ab',
        },
        tabs: {
            all: 'Alle (%{count})',
            valid: 'Gültig (%{count})',
            expired: 'Abgelaufen (%{count})',
        },
    },
    layout: {
        language: 'Sprache',
        profile: 'Profil',
        changePassword: 'Passwort ändern',
        help: 'Hilfe',
        logout: 'Ausloggen',
        loadingTranslations: 'Übersetzungen werden geladen...',
    },
    bottomNav: {
        catalogs: 'Kataloge',
        media: 'Medien',
        learningPaths: 'Lernpfade',
        achievements: 'Erfolge',
    },
    wiki: {
        title: 'Aktuelles & Wissen',
        newArticle: 'Neuer Artikel',
        searchPlaceholder: 'Artikel suchen (Titel und Zusammenfassung)...',
        categoriesButton: 'Kategorien',
        categoryLabel: 'Kategorie',
        allCategories: 'Alle Kategorien',
        noArticles: 'Keine Artikel gefunden',
        loading: 'Laden...',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        view: 'Ansehen',
        confirmDelete: 'Möchten Sie den Artikel "%{title}" wirklich löschen?',
        deleted: 'Artikel gelöscht',
        deleteError: 'Fehler beim Löschen',
        loadError: 'Fehler beim Laden der Artikel',
        company: 'Firma',
        platform: 'FAQ',
        updated: 'Aktualisiert',
        editor: {
            newArticle: 'Neuer Artikel',
            editArticle: 'Artikel bearbeiten',
            back: 'Zurück',
            save: 'Speichern',
            saving: 'Speichern...',
            saveAndPublish: 'Speichern & Veröffentlichen',
            title: 'Titel',
            slug: 'URL-Slug',
            slugHelp: 'URL-freundlicher Name (wird automatisch generiert)',
            summary: 'Zusammenfassung',
            summaryHelp: 'Kurze Beschreibung für die Artikelübersicht',
            status: 'Status',
            category: 'Kategorie',
            none: 'Keine',
            visibility: 'Sichtbarkeit',
            visibilityCompany: 'Firma (nur für Firmen-Benutzer sichtbar)',
            visibilityGlobal: 'Global (für alle Unternehmen sichtbar)',
            content: 'Inhalt',
            version: 'Version',
            versionHistory: 'Versionsverlauf',
        },
        status: {
            draft: 'Entwurf',
            published: 'Veröffentlicht',
            archived: 'Archiviert',
        },
        tabs: {
            all: 'Alle',
            drafts: 'Entwürfe',
            published: 'Veröffentlicht',
            archived: 'Archiviert',
        },
        favorites: 'Favoriten',
        noFavorites: 'Keine Favoriten vorhanden',
        noFavoritesHint: 'Markieren Sie Artikel als Favoriten, um sie hier schnell wiederzufinden.',
        categories: {
            title: 'Wiki-Kategorien',
            back: 'Zurück',
            newCategory: 'Neue Kategorie',
            editCategory: 'Kategorie bearbeiten',
            noCategories: 'Keine Kategorien vorhanden',
            loadError: 'Fehler beim Laden der Kategorien',
            saveError: 'Fehler beim Speichern',
            deleteError: 'Fehler beim Löschen',
            updateSuccess: 'Kategorie aktualisiert',
            createSuccess: 'Kategorie erstellt',
            deleteSuccess: 'Kategorie gelöscht',
            nameRequired: 'Bitte geben Sie einen Namen ein',
            confirmDelete: 'Möchten Sie die Kategorie "%{name}" wirklich löschen?',
            companyCategory: 'Firmen-Kategorie',
            globalCategory: 'Globale Kategorie',
            table: {
                name: 'Name',
                color: 'Farbe',
                icon: 'Icon',
                description: 'Beschreibung',
                type: 'Typ',
                actions: 'Aktionen',
            },
            form: {
                name: 'Name',
                color: 'Farbe',
                icon: 'Icon (Optional)',
                noIcon: 'Kein Icon',
                description: 'Beschreibung',
                globalCategory: 'Globale Kategorie (für alle Unternehmen sichtbar)',
            },
            isPublic: 'Öffentlich (FAQ)',
            isPublicHelp: 'Öffentliche Kategorien sind ohne Login unter /faq erreichbar',
        },
    },
    courses: {
        title: 'Kurse',
        catalog: 'Katalog',
        backToCatalogs: 'Zurück zu Katalogen',
        coursesIn: 'Kurse in: %{name}',
        newCourse: 'Neuer Kurs',
        editCourse: 'Kurs bearbeiten',
        createFirst: 'Ersten Kurs erstellen',
        manageLessons: 'Lektionen verwalten',
        fromLibrary: 'Aus Bibliothek',
        noCourses: 'Noch keine Kurse vorhanden',
        loading: 'Lade Kurse...',
        loadError: 'Fehler beim Laden des Katalogs',
        loadCoursesError: 'Fehler beim Laden der Kurse',
        saveError: 'Fehler beim Speichern des Kurses',
        deleteError: 'Fehler beim Archivieren des Kurses',
        updateSuccess: 'Kurs erfolgreich aktualisiert',
        createSuccess: 'Kurs erfolgreich erstellt',
        deleteSuccess: 'Kurs erfolgreich archiviert',
        confirmDelete: 'Möchten Sie diesen Kurs wirklich archivieren?\n\nDer Kurs wird für alle Teilnehmer unsichtbar und nicht mehr zugänglich. Bereits abgeschlossene Zertifikate bleiben erhalten. Statistiken werden nicht verändert.',
        sequential: 'Sequenziell',
        duration: '%{minutes} Min.',
        lessonsCount: '%{count} Lektionen',
        difficulty: {
            beginner: 'Einstieg',
            intermediate: 'Vertiefung',
            advanced: 'Spezialisierung',
        },
        form: {
            title: 'Titel',
            slug: 'Slug',
            slugHelp: 'URL-freundlicher Bezeichner (z.B. einfuehrung-javascript)',
            description: 'Beschreibung',
            estimatedDuration: 'Geschätzte Dauer (Minuten)',
            difficulty: 'Schwierigkeitsgrad',
            requireSequentialCompletion: 'Sequenzieller Abschluss erforderlich',
            active: 'Aktiv',
            tags: 'Tags',
            tagsHelp: 'Komma-getrennte Liste (z.B. react, javascript, frontend)',
            certificateType: 'Zertifikat für den Kursabschluss',
            certificateTypeParticipated: 'Zertifikat: Am Kurs teilgenommen',
            certificateTypePassed: 'Zertifikat: Kurs erfolgreich bestanden',
            certificateTypeNone: 'Kein Zertifikat ausstellen',
            certificateTypeRequired: 'Bitte festlegen, welches Zertifikat der Kurs ausstellt.',
            certificateTypePassedWithoutThreshold: 'Keine Lektion hat eine Mindestpunktzahl – jeder Abschluss gilt als bestanden. Die Mindestpunktzahl legst du pro Lektion fest.',
            aiTutorEnabled: 'KI-Lernassistent aktivieren',
            requireTeacherReviewForGrading: 'KI-Bewertungen erfordern Freigabe durch eine berechtigte Person (zertifikats-relevante Kurse)',
        },
    },
    catalogs: {
        title: 'Kursverwaltung',
        loading: 'Lade Kataloge...',
        loadError: 'Fehler beim Laden der Kataloge',
        newCatalog: 'Neuer Katalog',
        editCatalog: 'Katalog bearbeiten',
        manageCourses: 'Kurse verwalten',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        coursesCount: '%{count} Kurse',
        created: 'Erstellt',
        confirmDelete: 'Möchten Sie diesen Katalog wirklich löschen?',
        updateSuccess: 'Katalog erfolgreich aktualisiert',
        createSuccess: 'Katalog erfolgreich erstellt',
        deleteSuccess: 'Katalog erfolgreich gelöscht',
        saveError: 'Fehler beim Speichern des Katalogs',
        deleteError: 'Fehler beim Löschen des Katalogs',
        form: {
            name: 'Name',
            description: 'Beschreibung',
            active: 'Aktiv',
        },
    },
    lessons: {
        title: 'Lektionen',
        loading: 'Lade Lektionen...',
        loadError: 'Fehler beim Laden der Lektionen',
        loadCourseError: 'Fehler beim Laden des Kurses',
        newLesson: 'Neue Lektion',
        editLesson: 'Lektion bearbeiten',
        createFirst: 'Erste Lektion erstellen',
        fromLibrary: 'Aus Bibliothek',
        noLessons: 'Noch keine Lektionen vorhanden',
        lessonsFor: 'Lektionen: %{title}',
        backToCourses: 'Zurück zu Kursen',
        editContent: 'Inhalt bearbeiten',
        preview: 'Vorschau',
        mandatory: 'Pflicht',
        minScore: 'Min. %{score}%',
        updateSuccess: 'Lektion erfolgreich aktualisiert',
        createSuccess: 'Lektion erfolgreich erstellt',
        deleteSuccess: 'Lektion erfolgreich gelöscht',
        saveError: 'Fehler beim Speichern der Lektion',
        deleteError: 'Fehler beim Löschen der Lektion',
        confirmDelete: 'Möchten Sie diese Lektion wirklich endgültig löschen?\n\nDie Fortschrittsdaten der Teilnehmer werden automatisch angepasst.',
        learningContent: {
            label: 'Lerninhalt (optional)',
            helper: 'Dieser formatierte Text wird im Player über dem Quiz angezeigt.',
        },
        types: {
            video: 'Video',
            document: 'Dokument',
            infoText: 'Informationstext',
            multipleChoice: 'Multiple Choice',
            fillInBlank: 'Lückentext',
            freeText: 'Freitext',
            dragDrop: 'Drag & Drop',
            matching: 'Zuordnung',
            sorting: 'Sortierung',
            hotspot: 'Hotspot',
            timeline: 'Zeitstrahl',
            scorm: 'SCORM',
            h5p: 'H5P',
            xapi: 'xAPI',
        },
        form: {
            title: 'Titel',
            type: 'Typ',
            description: 'Beschreibung',
            estimatedDuration: 'Geschätzte Dauer (Minuten)',
            minScore: 'Minimale Punktzahl (%)',
            minScoreHelp: 'Prozentsatz, der zum Bestehen erreicht werden muss',
            isMandatory: 'Pflichtlektion',
            active: 'Aktiv',
            enablePeerReview: 'Peer-Review aktivieren',
            peerReviewInfo: 'Wenn aktiviert, müssen Teilnehmer ihre Antwort einreichen und erhalten Feedback von anderen Kursteilnehmern.',
            minPeerReviews: 'Mindestanzahl Reviews',
            minPeerReviewsHelp: 'Anzahl der Reviews, die jede Einreichung erhalten muss (1-10)',
            peerReviewCriteria: 'Bewertungskriterien',
            criterionName: 'Kriterium',
            criterionDescription: 'Beschreibung',
            maxPoints: 'Max. Punkte',
            addCriterion: 'Kriterium hinzufügen',
            aiTutor: 'KI-Lernassistent',
            aiTutorInherit: 'Vom Kurs übernehmen',
            aiTutorEnabled: 'Aktiviert',
            aiTutorDisabled: 'Deaktiviert',
        },
        peerReview: 'Peer-Review',
    },
    courseRating: {
        title: 'Kurs bewerten',
        editTitle: 'Bewertung bearbeiten',
        rateButton: 'Bewerten',
        editButton: 'Bewertung ändern',
        yourRating: 'Ihre Bewertung',
        comment: 'Kommentar (optional)',
        commentPlaceholder: 'Was hat Ihnen an diesem Kurs gefallen oder was könnte verbessert werden?',
        submitSuccess: 'Bewertung erfolgreich gespeichert',
        updateSuccess: 'Bewertung erfolgreich aktualisiert',
        deleteSuccess: 'Bewertung erfolgreich gelöscht',
        noRatings: 'Noch keine Bewertungen',
        ratings: '%{count} Bewertungen',
        averageRating: 'Durchschnitt',
        labels: {
            terrible: 'Schlecht',
            poor: 'Mäßig',
            ok: 'In Ordnung',
            good: 'Gut',
            excellent: 'Ausgezeichnet',
        },
        errors: {
            ratingRequired: 'Bitte wählen Sie eine Bewertung aus',
            saveFailed: 'Fehler beim Speichern der Bewertung',
            deleteFailed: 'Fehler beim Löschen der Bewertung',
        },
    },
    prerequisites: {
        title: 'Voraussetzungen',
        noPrerequisites: 'Keine Voraussetzungen',
        completed: 'Abgeschlossen',
        required: 'Erforderlich',
        recommended: 'Empfohlen',
        hard: 'Pflicht',
        soft: 'Empfohlen',
        clickToView: 'Klicken zum Anzeigen',
        status: {
            noRequired: 'Keine Voraussetzungen',
            allMet: 'Alle erfüllt',
            allMetTooltip: 'Sie haben alle Voraussetzungen erfüllt',
            blocked: '%{count} Pflicht nicht erfüllt',
            blockedTooltip: 'Sie müssen zuerst folgende Kurse abschließen: %{courses}',
            recommended: '%{count} empfohlen',
            warningTooltip: 'Folgende Kurse werden empfohlen: %{courses}',
        },
        warningDialog: {
            title: 'Empfohlene Voraussetzungen',
            message: 'Für den Kurs "%{course}" werden folgende Kurse empfohlen, die Sie noch nicht abgeschlossen haben.',
            recommendedCourses: 'Empfohlene Kurse:',
            proceedAnyway: 'Sie können trotzdem fortfahren, aber wir empfehlen, zuerst die folgenden Kurse abzuschließen.',
            goBack: 'Zurück',
            proceedButton: 'Trotzdem einschreiben',
        },
        blockDialog: {
            title: 'Voraussetzungen nicht erfüllt',
            message: 'Sie können sich nicht für den Kurs "%{course}" einschreiben, da Sie die erforderlichen Voraussetzungen noch nicht erfüllt haben.',
            requiredCourses: 'Erforderliche Kurse:',
            completeFirst: 'Bitte schließen Sie diese Kurse zuerst ab, um sich einschreiben zu können.',
        },
    },
    gamification: {
        achievements: 'Meine Erfolge',
        badgesTitle: 'Auszeichnungen',
        streakTitle: 'Lernserie',
        leaderboardTitle: 'Rangliste',
        fullLeaderboard: 'Vollständige Rangliste',
        earned: 'Verdient',
        available: 'Verfügbar',
        noBadgesYet: 'Sie haben noch keine Auszeichnungen verdient. Schließen Sie Kurse ab, um Auszeichnungen zu erhalten!',
        allBadgesEarned: 'Herzlichen Glückwunsch! Sie haben alle verfügbaren Auszeichnungen verdient.',
        days: 'Tage',
        currentStreak: 'Aktuelle Serie',
        longestStreak: 'Längste Serie',
        rank: 'Rang',
        streakAtRisk: 'Ihre Serie ist in Gefahr! Lernen Sie heute noch etwas.',
        streakAtRiskMessage: 'Lernen Sie heute, um Ihre Serie zu erhalten!',
        streakTooltip: '%{days} Tage Lernserie',
        badgeEarned: 'Auszeichnung verdient!',
        awesome: 'Super!',
        congratulations: 'Herzlichen Glückwunsch!',
        leaderboard: {
            rank: 'Rang',
            user: 'Benutzer',
            courses: 'Kurse',
            badges: 'Auszeichnungen',
            streakDays: 'Serien-Tage',
            byCourses: 'Nach Kursen',
            byBadges: 'Nach Auszeichnungen',
            byStreak: 'Nach Serie',
            you: 'Sie',
            yourPosition: 'Ihre Position',
        },
    },
    learningPaths: {
        title: 'Lernpfade',
        myPaths: 'Meine Lernpfade',
        explore: 'Lernpfade entdecken',
        courses: 'Kurse',
        search: 'Lernpfad suchen...',
        difficulty: 'Schwierigkeit',
        allDifficulties: 'Alle',
        beginner: 'Einstieg',
        intermediate: 'Vertiefung',
        advanced: 'Spezialisierung',
        noPathsFound: 'Keine Lernpfade gefunden',
        noEnrollments: 'Keine aktiven Lernpfade',
        exploreDescription: 'Entdecke Lernpfade und starte deine Lernreise',
        progress: 'Fortschritt',
        yourProgress: 'Dein Fortschritt',
        enroll: 'Einschreiben',
        enrollNow: 'Jetzt einschreiben',
        enrollSuccess: 'Erfolgreich eingeschrieben!',
        continue: 'Fortsetzen',
        viewCertificate: 'Ansehen',
        start: 'Starten',
        completed: 'Abgeschlossen',
        completedOn: 'Abgeschlossen am',
        courseList: 'Kursübersicht',
        required: 'Pflicht',
        optional: 'Optional',
        status: {
            enrolled: 'Eingeschrieben',
            inProgress: 'In Bearbeitung',
            completed: 'Abgeschlossen',
        },
    },
    common: {
        back: 'Zurück',
        viewAll: 'Alle anzeigen',
        cancel: 'Abbrechen',
        save: 'Speichern',
        saving: 'Speichern...',
        delete: 'Löschen',
    },
    recommendations: {
        title: 'Empfohlen für Sie',
        similarCourses: 'Ähnliche Kurse',
        enroll: 'Einschreiben',
        noRecommendations: 'Keine Empfehlungen verfügbar',
        reasons: {
            sameCatalog: 'Aus Ihrem bevorzugten Katalog',
            nextDifficulty: 'Nächster Schwierigkeitsgrad',
            sameDifficulty: 'Passender Schwierigkeitsgrad',
            matchingTags: 'Ähnliche Themen',
            prerequisitesMet: 'Voraussetzungen erfüllt',
            popular: 'Bei anderen Lernenden beliebt',
            beginnerFriendly: 'Ideal für Einsteiger',
        },
    },
    notifications: {
        title: 'Benachrichtigungen',
        noNotifications: 'Keine Benachrichtigungen',
        markAllRead: 'Alle gelesen',
        justNow: 'Gerade eben',
        minutesAgo: 'Vor %{count} Min.',
        hoursAgo: 'Vor %{count} Std.',
        daysAgo: 'Vor %{count} Tagen',
        types: {
            course_completed: 'Kurs abgeschlossen',
            certificate_earned: 'Zertifikat erhalten',
            badge_earned: 'Auszeichnung verdient',
            learning_path_completed: 'Lernpfad abgeschlossen',
            streak_milestone: 'Serien-Meilenstein',
            system: 'Systemnachricht',
        },
    },
    emptyStates: {
        noCourses: {
            title: 'Keine Kurse gefunden',
            description: 'Es sind noch keine Kurse verfügbar. Schauen Sie später wieder vorbei!',
            action: 'Kurskataloge durchsuchen',
        },
        noBadges: {
            title: 'Noch keine Auszeichnungen',
            description: 'Schließen Sie Kurse ab und erreichen Sie Meilensteine, um Auszeichnungen zu verdienen!',
        },
        noLearningPaths: {
            title: 'Keine Lernpfade',
            description: 'Sie haben sich noch für keinen Lernpfad eingeschrieben.',
            action: 'Lernpfade entdecken',
        },
        noRecommendations: {
            title: 'Keine Empfehlungen',
            description: 'Schließen Sie mehr Kurse ab, um personalisierte Empfehlungen zu erhalten.',
        },
        noEnrollments: {
            title: 'Noch keine Kurse',
            description: 'Sie haben sich noch für keinen Kurs eingeschrieben. Entdecken Sie unseren Kurskatalog!',
            action: 'Kurse entdecken',
        },
        noSearchResults: {
            title: 'Keine Ergebnisse',
            description: 'Versuchen Sie andere Suchbegriffe.',
            descriptionWithTerm: 'Keine Ergebnisse für "%{term}" gefunden. Versuchen Sie andere Suchbegriffe.',
        },
    },
    bookmarks: {
        title: 'Meine Lesezeichen',
        add: 'Lesezeichen hinzufügen',
        remove: 'Lesezeichen entfernen',
        noBookmarks: 'Keine Lesezeichen vorhanden. Speichern Sie interessante Kurse für später!',
        errorLoading: 'Fehler beim Laden der Lesezeichen',
        savedOn: 'Gespeichert am',
        editNote: 'Notiz bearbeiten',
        noteLabel: 'Notiz',
        notePlaceholder: 'Warum möchten Sie diesen Kurs speichern?',
    },
    progress: {
        weeklyTitle: 'Diese Woche',
        errorLoading: 'Fehler beim Laden des Fortschritts',
        lessonsCompleted: 'Lektionen',
        coursesCompleted: 'Kurse',
        activeDays: 'Aktive Tage',
        dailyActivity: 'Tägliche Aktivität',
        lessons: 'Lektionen',
        overallProgress: 'Gesamtfortschritt',
        coursesLabel: 'Kurse',
        inProgress: 'In Bearbeitung',
        complete: 'abgeschlossen',
        days: {
            mon: 'Mo',
            tue: 'Di',
            wed: 'Mi',
            thu: 'Do',
            fri: 'Fr',
            sat: 'Sa',
            sun: 'So',
        },
    },
    notes: {
        notes: 'Notizen',
        add: 'Hinzufügen',
        addNote: 'Notiz hinzufügen',
        newNote: 'Neue Notiz',
        editNote: 'Notiz bearbeiten',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        title: 'Titel',
        titlePlaceholder: 'Optionaler Titel...',
        content: 'Inhalt',
        contentPlaceholder: 'Schreiben Sie Ihre Notiz hier...',
        color: 'Farbe',
        privateNote: 'Private Notiz',
        private: 'Privat',
        public: 'Öffentlich',
        untitled: 'Ohne Titel',
        noNotes: 'Noch keine Notizen vorhanden',
        noLessonNotes: 'Keine Notizen für diese Lektion',
        createFirst: 'Erste Notiz erstellen',
        createFirstNote: 'Erstellen Sie Ihre erste Notiz in einem Kurs',
        currentLesson: 'Aktuelle Lektion',
        otherCourseNotes: 'Notizen aus anderen Lektionen',
        errorLoading: 'Fehler beim Laden der Notizen',
        loadError: 'Fehler beim Laden der Notizen',
        deleteConfirmTitle: 'Notiz löschen?',
        deleteConfirmMessage: 'Sind Sie sicher, dass Sie diese Notiz löschen möchten?',
        // Overview page
        myNotes: 'Meine Notizen',
        overviewDescription: 'Alle Ihre Notizen aus allen Kursen an einem Ort.',
        search: 'Notizen durchsuchen...',
        sort: 'Sortieren',
        filter: 'Filtern',
        sortByDate: 'Nach Datum',
        sortByTitle: 'Nach Titel',
        sortByCourse: 'Nach Kurs',
        filterAll: 'Alle Notizen',
        filterWithLesson: 'Mit Lektion verknüpft',
        filterCourseOnly: 'Nur Kurs-Notizen',
        totalNotes: '%{count} Notizen',
        totalCourses: '%{count} Kurse',
        notesCount: '%{count} Notizen',
        notesLabel: 'Notizen',
        coursesLabel: 'Kurse',
        noSearchResults: 'Keine Notizen gefunden',
        tryDifferentSearch: 'Versuchen Sie einen anderen Suchbegriff',
        goToCourse: 'Zum Kurs',
        courseUnavailable: 'Kurs nicht mehr verfügbar',
        exportPdf: 'Als PDF herunterladen',
        exportPdfShort: 'PDF',
    },
    search: {
        title: 'Suche',
        placeholder: 'Kurse, Aktuelles & Wissen, Lernpfade durchsuchen...',
        resultsFor: 'Ergebnisse für "%{query}"',
        results: 'Ergebnisse',
        noResults: 'Keine Ergebnisse gefunden',
        tryDifferentTerms: 'Versuchen Sie andere Suchbegriffe',
        enterQuery: 'Geben Sie einen Suchbegriff ein',
        errorSearch: 'Fehler bei der Suche',
        filters: 'Filter',
        contentType: 'Inhaltstyp',
        difficultyLabel: 'Schwierigkeit',
        allDifficulties: 'Alle Schwierigkeiten',
        fromCourse: 'Aus Kurs',
        types: {
            course: 'Kurs',
            lesson: 'Lektion',
            wiki: 'Aktuelles & Wissen',
            learningPath: 'Lernpfad',
            learningGroup: 'Lerngruppe',
        },
        difficulty: {
            beginner: 'Einstieg',
            intermediate: 'Vertiefung',
            advanced: 'Spezialisierung',
        },
    },
    export: {
        button: 'Export',
        dialog: {
            title: 'Daten exportieren',
        },
        forCourse: 'Für Kurs',
        general: 'Allgemeine Exporte',
        success: 'Export erfolgreich heruntergeladen!',
        'learning-history': {
            label: 'Lernhistorie',
            description: 'Komplette Übersicht aller Kurse und Fortschritte',
        },
        transcript: {
            label: 'Kurs-Transkript',
            description: 'Detaillierter Bericht über diesen Kurs',
        },
        notes: {
            label: 'Notizen',
            description: 'Ihre persönlichen Notizen als PDF',
        },
        'progress-report': {
            label: 'Fortschrittsbericht',
            description: 'CSV-Export mit detaillierten Fortschrittsdaten',
        },
    },
    analytics: {
        title: 'Meine Lernstatistiken',
        errorLoading: 'Fehler beim Laden der Analytics',
        totalCourses: 'Kurse gesamt',
        completedCourses: 'Abgeschlossen',
        inProgress: 'in Bearbeitung',
        learningTime: 'Lernzeit',
        achievements: 'Erfolge',
        completionRate: 'Abschlussrate',
        lessonsCompleted: 'Abgeschlossene Lektionen',
        learningTimePerDay: 'Lernzeit pro Tag',
        recentCompletions: 'Letzte Abschlüsse',
        noCompletions: 'Noch keine Abschlüsse',
        progressSummary: 'Fortschrittsübersicht',
        avgProgress: 'Durchschnittlicher Fortschritt',
        avgScore: 'Durchschnittliche Punktzahl',
        myCourses: 'Meine Kurse',
        noCourses: 'Keine Kurse vorhanden',
        enrolled: 'Eingeschrieben',
        time: 'Zeit',
        activityOverview: 'Aktivitätsübersicht',
        enrollmentTrend: 'Einschreibungen',
        completionTrend: 'Kursabschlüsse',
        inLast: 'In den letzten',
        days: 'Tagen',
        noCourseData: 'Keine Kursdaten vorhanden',
        course: 'Kurs',
        participants: 'Teilnehmer',
        period: {
            week: '7 Tage',
            month: '30 Tage',
            quarter: '90 Tage',
        },
        tabs: {
            overview: 'Übersicht',
            courses: 'Kurse',
            activity: 'Aktivität',
        },
        status: {
            completed: 'Abgeschlossen',
            inProgress: 'In Bearbeitung',
            enrolled: 'Eingeschrieben',
        },
        instructor: {
            title: 'Trainer-Dashboard',
            subtitle: 'Übersicht über die Performance Ihrer Kurse',
            errorLoading: 'Fehler beim Laden der Trainer-Statistiken',
            noCourses: 'Sie haben noch keine Kurse erstellt',
            createCourse: 'Erstellen Sie einen Kurs, um Statistiken zu sehen',
            myCourses: 'Meine Kurse',
            participants: 'Teilnehmer',
            enrollments: 'Einschreibungen',
            completions: 'Abschlüsse',
            completionRate: 'Abschlussrate',
            avgProgress: 'Ø Fortschritt',
            avgProgressShort: 'Ø Fortschritt',
            avgScore: 'Ø Punkte',
            courseOverview: 'Kursübersicht',
            course: 'Kurs',
            enrolled: 'Eingeschrieben',
            completed: 'Abgeschlossen',
            lessonDetails: 'Lektionsdetails',
            selectCourse: 'Wählen Sie einen Kurs aus der Tabelle',
            courseStatsError: 'Die Kursstatistik konnte nicht geladen werden',
            lesson: 'Lektion',
            attempts: 'Versuche',
            lessonCompletions: 'Abschlüsse',
            avgTime: 'Ø Zeit',
        },
    },
    privacy: {
        title: 'Datenschutz',
        subtitle: 'Lade eine vollständige Kopie deiner Daten herunter (Art. 15/20 DSGVO) oder lösche dein Konto (Art. 17 DSGVO).',
        exportButton: 'Meine Daten herunterladen (PDF)',
        exportButtonJson: 'Als JSON für andere Anbieter',
        exportSuccess: 'Dein Datenexport wurde heruntergeladen.',
        exportError: 'Export fehlgeschlagen. Bitte versuche es erneut.',
        deleteButton: 'Konto löschen',
        deleteTitle: 'Löschung deines Kontos beantragen?',
        deleteWarning: 'Dein Unternehmens-Administrator erhält deinen Antrag und entscheidet innerhalb eines Monats. Nach der Genehmigung wird dein Konto anonymisiert und nach der Aufbewahrungsfrist endgültig gelöscht. Entscheidet bis dahin niemand, wird es automatisch gelöscht. Bis zur Entscheidung kannst du dich weiter anmelden und den Antrag zurückziehen.',
        deleteConfirmButton: 'Löschung beantragen',
        deleteConfirmLabel: 'Zur Bestätigung "LÖSCHEN" eingeben',
        deleteConfirmWord: 'LÖSCHEN',
        deleteSuccess: 'Dein Löschantrag ist eingegangen. Dein Unternehmens-Administrator entscheidet bis zum %{dueAt}.',
        pendingTitle: 'Löschantrag gestellt',
        pendingText: 'Du hast am %{requestedAt} beantragt, dein Konto zu löschen. Dein Unternehmens-Administrator entscheidet bis zum %{dueAt}.',
        withdrawButton: 'Antrag zurückziehen',
        withdrawSuccess: 'Dein Löschantrag wurde zurückgezogen.',
        cancel: 'Abbrechen',
    },
    aiGrading: {
        disclaimer: 'Deine Antwort wird durch ein KI-System vorbewertet. Bitte gib keine sensiblen persönlichen Informationen ein. Du hast jederzeit das Recht auf eine Überprüfung durch deine Trainer:in.',
        attribution: 'KI-assistierte Bewertung — bei Beanstandung wende dich an deine Trainer:in.',
        model: 'Modell',
        reviewPending: 'Diese Bewertung wird von deiner Trainer:in geprüft und zählt erst nach der Freigabe.',
        reviewPendingLesson: 'Deine Antworten wurden eingereicht. Die KI-Vorbewertung wird von deiner Trainer:in geprüft — die Lektion wird nach der Freigabe automatisch abgeschlossen.',
    },
    aiReview: {
        title: 'KI-Bewertungen prüfen',
        subtitle: 'KI-vorbewertete Freitext-Antworten deiner Lernenden. Bei Kursen mit Pflicht-Review zählt die Bewertung erst nach deiner Freigabe zum Abschluss.',
        status: 'Status',
        all: 'Alle',
        minScore: 'Score ab',
        maxScore: 'Score bis',
        course: 'Kurs / Lektion',
        answer: 'Antwort',
        score: 'KI-Score',
        statusCol: 'Status',
        date: 'Eingereicht',
        actions: 'Aktionen',
        approve: 'Freigeben',
        override: 'Übersteuern',
        overrideTitle: 'Bewertung übersteuern',
        overrideHint: 'KI-Vorschlag',
        newScore: 'Neuer Score',
        newFeedback: 'Feedback an die lernende Person',
        originalAi: 'KI ursprünglich',
        cancel: 'Abbrechen',
        save: 'Speichern',
        approved: 'Bewertung freigegeben.',
        approvedCompleted: 'Freigegeben — Lektion wurde abgeschlossen.',
        overridden: 'Bewertung übersteuert.',
        empty: 'Keine KI-Bewertungen für die aktuelle Filterung.',
    },
    tutor: {
        title: 'KI-Lernassistent',
        aiLabel: 'KI',
        disclaimerTitle: 'Du chattest mit einer KI',
        disclaimerBody: 'Der Lernassistent ist ein KI-System. Antworten können ungenau oder unvollständig sein — verlasse dich bei wichtigen Fragen nicht allein darauf und frage im Zweifel deine Trainer:in. Deine Konversationen sind privat, werden auf unseren eigenen Servern verarbeitet und du kannst sie jederzeit löschen. Bitte gib keine sensiblen persönlichen Informationen ein.',
        disclaimerAccept: 'Verstanden',
        newConversation: 'Neues Gespräch',
        history: 'Verlauf',
        noConversations: 'Keine früheren Gespräche',
        welcomeTitle: 'Hallo! Ich bin dein Lernassistent.',
        welcomeWithLesson: 'Stelle mir Fragen zur Lektion "%{lesson}"',
        welcomeGeneral: 'Stelle mir eine Frage zum Kursinhalt.',
        inputPlaceholder: 'Stelle eine Frage...',
        inputWithLesson: 'Frage zu "%{lesson}"...',
        quickHelpLabel: 'Schnelle Hilfe',
        quickHelp: {
            explain: 'Einfacher',
            explainTooltip: 'Erkläre diesen Inhalt einfacher',
            example: 'Beispiel',
            exampleTooltip: 'Zeige mir ein Beispiel',
            quiz: 'Teste mich',
            quizTooltip: 'Stelle mir eine Frage zum Testen',
            summary: 'Zusammenfassung',
            summaryTooltip: 'Fasse den Inhalt zusammen',
        },
        error: 'Fehler bei der Anfrage',
        loadError: 'Fehler beim Laden',
    },
    learningGroups: {
        title: 'Lerngruppen',
        myGroups: 'Meine Lerngruppen',
        explore: 'Lerngruppen entdecken',
        createGroup: 'Lerngruppe erstellen',
        noGroups: 'Keine Lerngruppen gefunden',
        noMyGroups: 'Sie sind noch keiner Lerngruppe beigetreten',
        loading: 'Lade Lerngruppen...',
        members: '%{count} Mitglieder',
        maxMembers: 'Max. %{count} Mitglieder',
        course: 'Kurs',
        public: 'Öffentlich',
        private: 'Nur auf Einladung',
        join: 'Beitreten',
        leave: 'Austreten',
        viewGroup: 'Gruppe ansehen',
        createdBy: 'Erstellt von %{name}',
        joinSuccess: 'Erfolgreich beigetreten!',
        leaveSuccess: 'Gruppe verlassen',
        errorJoining: 'Fehler beim Beitreten',
        errorLeaving: 'Fehler beim Verlassen',
        createDialog: {
            title: 'Neue Lerngruppe erstellen',
            name: 'Gruppenname',
            namePlaceholder: 'z.B. JavaScript Einsteiger',
            description: 'Beschreibung',
            descriptionPlaceholder: 'Beschreibe worum es in der Gruppe geht...',
            course: 'Kurs (optional)',
            selectCourse: 'Kurs auswählen',
            noCourse: 'Kein Kurs',
            maxMembers: 'Max. Mitglieder',
            maxMembersHelp: 'Leer lassen für unbegrenzt',
            isPublic: 'Öffentliche Gruppe',
            isPublicHelp: 'Öffentliche Gruppen können von jedem beigetreten werden',
        },
        detail: {
            members: 'Mitglieder',
            chat: 'Gruppenchat',
            admin: 'Admin',
            member: 'Mitglied',
            noMessages: 'Noch keine Nachrichten. Starte die Konversation!',
            typePlaceholder: 'Nachricht schreiben...',
            send: 'Senden',
            you: 'Du',
            errorLoading: 'Fehler beim Laden der Gruppe',
            errorSending: 'Fehler beim Senden',
        },
        tabs: {
            myGroups: 'Meine Lerngruppen',
            explore: 'Erkunden',
        },
    },
    peerReview: {
        title: 'Peer-Reviews',
        tabs: {
            toReview: 'Zu bewerten',
            mySubmissions: 'Meine Abgaben (%{count})',
        },
        noPendingReviews: 'Keine ausstehenden Reviews',
        noSubmissions: 'Keine Abgaben vorhanden',
        status: {
            pending: 'Ausstehend',
            inReview: 'In Bearbeitung',
            completed: 'Abgeschlossen',
        },
        assignedOn: 'Zugewiesen am %{date}',
        submittedOn: 'Eingereicht am %{date}',
        reviewsReceived: '%{count} Reviews',
        review: 'Bewerten',
        viewFeedback: 'Feedback ansehen',
        notFound: 'Auftrag nicht gefunden',
        submitTitle: 'Abgabe zur Peer-Review einreichen',
        submitDescription: 'Reichen Sie Ihre Arbeit zur Lektion "%{lesson}" ein. Andere Teilnehmer werden Ihre Abgabe bewerten.',
        submissionLabel: 'Ihre Abgabe',
        submissionPlaceholder: 'Beschreiben Sie Ihre Lösung oder fügen Sie Ihren Text hier ein...',
        submit: 'Einreichen',
        submitSuccess: 'Ihre Abgabe wurde erfolgreich eingereicht und wird von anderen Teilnehmern bewertet.',
        reviewTitle: 'Peer-Review: %{lesson}',
        submissionToReview: 'Zu bewertende Abgabe',
        criteria: 'Bewertungskriterien',
        yourReview: 'Ihre Bewertung',
        ratingLabel: 'Gesamtbewertung',
        feedbackLabel: 'Ihr Feedback',
        feedbackPlaceholder: 'Geben Sie konstruktives Feedback zur Abgabe. Was war gut? Was könnte verbessert werden?',
        submitReview: 'Bewertung absenden',
        resultTitle: 'Feedback für: %{lesson}',
        yourSubmission: 'Ihre Abgabe',
        averageRating: 'Durchschnittliche Bewertung',
        reviewCount: '%{count} Reviews',
        receivedFeedback: 'Erhaltenes Feedback',
        noFeedbackYet: 'Noch kein Feedback erhalten. Ihre Abgabe wird noch bearbeitet.',
        reviewer: 'Reviewer %{number}',
        reviewedOn: 'Bewertet am %{date}',
        attachFile: 'Datei anhängen',
        fileHint: 'Optional: PDF, Word, Text, Bilder oder ZIP (max. 10MB)',
        downloadAttachment: 'Anhang herunterladen',
        errors: {
            submissionRequired: 'Bitte geben Sie Ihre Abgabe ein',
            ratingRequired: 'Bitte geben Sie eine Bewertung ab',
            feedbackRequired: 'Bitte geben Sie Feedback ein',
            fileTooLarge: 'Datei zu groß (max. 10MB)',
        },
    },
    faq: {
        title: 'Hilfe & FAQ',
        subtitle: 'Finden Sie Antworten auf häufig gestellte Fragen',
        searchPlaceholder: 'FAQ durchsuchen...',
        allCategories: 'Alle',
        noResults: 'Keine FAQ-Einträge zu Ihrer Suche gefunden.',
        noArticles: 'Noch keine FAQ-Einträge vorhanden.',
        loadError: 'Fehler beim Laden der FAQ',
        contentError: 'Inhalt konnte nicht geladen werden.',
        noContent: 'Kein Inhalt verfügbar.',
        contactSupport: 'Ihre Frage nicht gefunden? Kontaktieren Sie unseren Support.',
    },
    products: {
        title: 'Produkte',
        searchPlaceholder: 'Produkte suchen...',
        filterType: 'Typ',
        filterVisibility: 'Sichtbarkeit',
        allTypes: 'Alle Typen',
        allVisibility: 'Alle',
        loadError: 'Fehler beim Laden der Produkte',
        noProducts: 'Keine Produkte verfügbar.',
        noSearchResults: 'Keine Produkte für Ihre Suche gefunden.',
        featured: 'Empfohlen',
        inactive: 'Inaktiv',
        noPrice: 'Kein Preis festgelegt',
        types: {
            course: 'Kurs',
            catalog: 'Katalog',
            bundle: 'Paket',
            libraryItem: 'Bibliothekseintrag',
        },
        visibility: {
            public: 'Öffentlich',
            private: 'Privat',
            unlisted: 'Nicht gelistet',
        },
        pricing: {
            free: 'Kostenlos',
            oneTime: 'Einmalzahlung',
            subscription: 'Abonnement',
            perMonth: 'pro Monat',
            perYear: 'pro Jahr',
        },
        actions: {
            view: 'Ansehen',
            edit: 'Bearbeiten',
            delete: 'Löschen',
            addToCart: 'In den Warenkorb',
            enroll: 'Jetzt anmelden',
        },
    },
    library: {
        title: 'Inhaltsbibliothek',
        tabs: {
            myLibrary: 'Meine Bibliothek',
            operatorLibrary: 'Plattform-Bibliothek',
            company: 'Meine Bibliothek',
            operator: 'Plattform-Bibliothek',
        },
        search: 'Bibliothek durchsuchen...',
        selectDialog: {
            titleCourse: 'Kurs aus Bibliothek einfügen',
            titleLesson: 'Lektion aus Bibliothek einfügen',
        },
        types: {
            course: 'Kurs',
            lesson: 'Lektion',
        },
        access: {
            copyAllowed: 'Kopie erlaubt',
            referenceOnly: 'Nur Referenz',
        },
        operatorContent: 'Plattform-Inhalt',
        usageCount: '%{count}x verwendet',
        version: 'Version %{version}',
        searchPlaceholder: 'Bibliothek durchsuchen...',
        filterType: 'Typ',
        allTypes: 'Alle Typen',
        refresh: 'Aktualisieren',
        loadError: 'Fehler beim Laden der Bibliothek',
        noSearchResults: 'Keine Ergebnisse für Ihre Suche gefunden.',
        noItems: 'Noch keine Einträge in der Bibliothek.',
        insertSuccess: '"%{title}" erfolgreich eingefügt',
        insertError: 'Fehler beim Einfügen aus der Bibliothek',
        confirmDelete: 'Möchten Sie "%{title}" wirklich aus der Bibliothek löschen?',
        deleteSuccess: 'Erfolgreich aus der Bibliothek gelöscht',
        deleteError: 'Fehler beim Löschen',
        actions: {
            insert: 'Einfügen',
            edit: 'Bearbeiten',
            delete: 'Löschen',
            share: 'Freigeben',
        },
        saveDialog: {
            title: 'In Bibliothek speichern',
            titleLabel: 'Titel',
            descriptionLabel: 'Beschreibung',
            tagsLabel: 'Schlagworte',
            tagsPlaceholder: 'Schlagwort eingeben...',
            tagsHelp: 'Drücken Sie Enter, um ein Schlagwort hinzuzufügen',
            operatorContent: 'Als Plattform-Inhalt speichern',
            operatorContentHint: 'Plattform-Inhalte können für Mandanten freigegeben werden und sind nur für Operatoren sichtbar.',
            save: 'In Bibliothek speichern',
            titleRequired: 'Titel ist erforderlich',
            success: 'Erfolgreich in der Bibliothek gespeichert',
            error: 'Fehler beim Speichern in der Bibliothek',
        },
        insertDialog: {
            title: 'Aus Bibliothek einfügen',
            description: 'Wählen Sie, wie der Inhalt eingefügt werden soll:',
            copyNotAllowed: 'Für diesen Inhalt ist nur der Referenz-Modus verfügbar.',
            copyOption: 'Kopie erstellen',
            copyDescription: 'Erstellt eine unabhängige Kopie, die Sie frei bearbeiten können.',
            referenceOption: 'Referenz erstellen',
            referenceDescription: 'Bleibt mit dem Original verknüpft. Sie erhalten Benachrichtigungen bei Updates.',
            confirm: 'Einfügen',
            courseCreated: 'Kurs "%{title}" erfolgreich %{mode}',
            lessonCreated: 'Lektion "%{title}" erfolgreich %{mode}',
            asCopy: 'als Kopie erstellt',
            asReference: 'als Referenz erstellt',
        },
        sharing: {
            title: 'Inhalt freigeben',
            description: 'Wählen Sie die Mandanten aus, für die dieser Inhalt freigegeben werden soll.',
            noCompanies: 'Keine Mandanten verfügbar.',
            loadError: 'Fehler beim Laden der Mandanten.',
            saveSuccess: 'Freigaben erfolgreich gespeichert.',
            saveError: 'Fehler beim Speichern der Freigaben.',
            revokeSuccess: 'Freigabe erfolgreich entzogen.',
            revokeError: 'Fehler beim Entziehen der Freigabe.',
            revoke: 'Freigabe entziehen',
            accessType: 'Zugriffstyp',
            readonly: 'Nur Referenz (schreibgeschützt)',
            copyAllowed: 'Kopie erlaubt',
            expiresAt: 'Ablaufdatum',
            expiresAtHelp: 'Leer lassen für unbegrenzten Zugang',
        },
        updates: {
            title: 'Verfügbare Updates',
            description: '%{count} Inhalt(e) haben Updates von der Bibliothek verfügbar.',
            checking: 'Prüfe auf Updates...',
            apply: 'Update anwenden',
            applySuccess: 'Update erfolgreich angewendet.',
            applyError: 'Fehler beim Anwenden des Updates.',
            versionChange: 'Version %{from} → %{to}',
            noUpdates: 'Alle Inhalte sind aktuell.',
        },
    },
    cart: {
        title: 'Warenkorb',
        empty: {
            title: 'Ihr Warenkorb ist leer',
            description: 'Entdecken Sie unsere Produkte und fügen Sie sie zu Ihrem Warenkorb hinzu.',
        },
        unknownProduct: 'Unbekanntes Produkt',
        subtotal: 'Zwischensumme',
        discount: 'Rabatt',
        tax: 'MwSt.',
        total: 'Gesamtsumme',
        actions: {
            checkout: 'Zur Kasse',
            continueShopping: 'Weiter einkaufen',
            clear: 'Leeren',
            remove: 'Entfernen',
        },
        messages: {
            itemAdded: 'Produkt zum Warenkorb hinzugefügt',
            itemRemoved: 'Produkt aus dem Warenkorb entfernt',
            cartCleared: 'Warenkorb geleert',
            addError: 'Fehler beim Hinzufügen zum Warenkorb',
            removeError: 'Fehler beim Entfernen aus dem Warenkorb',
            updateError: 'Fehler beim Aktualisieren des Warenkorbs',
            clearError: 'Fehler beim Leeren des Warenkorbs',
        },
    },
    orders: {
        title: 'Meine Bestellungen',
        loading: 'Bestellungen werden geladen...',
        noOrders: 'Keine Bestellungen vorhanden.',
        orderNumber: 'Bestellnummer',
        orderDate: 'Bestelldatum',
        items: 'Artikel',
        total: 'Gesamtsumme',
        status: {
            pending: 'Ausstehend',
            paid: 'Bezahlt',
            completed: 'Abgeschlossen',
            cancelled: 'Storniert',
            refunded: 'Erstattet',
        },
        paymentStatus: {
            pending: 'Ausstehend',
            processing: 'In Bearbeitung',
            completed: 'Abgeschlossen',
            failed: 'Fehlgeschlagen',
        },
        actions: {
            view: 'Details anzeigen',
            cancel: 'Stornieren',
            download: 'Rechnung herunterladen',
        },
        detail: {
            title: 'Bestelldetails',
            customerInfo: 'Kundendaten',
            billingAddress: 'Rechnungsadresse',
            orderItems: 'Bestellte Artikel',
            paymentInfo: 'Zahlungsinformationen',
        },
        messages: {
            cancelSuccess: 'Bestellung erfolgreich storniert',
            cancelError: 'Fehler beim Stornieren der Bestellung',
        },
    },
    checkout: {
        title: 'Kasse',
        steps: {
            review: 'Überprüfen',
            customer: 'Kundendaten',
            payment: 'Zahlung',
            confirmation: 'Bestätigung',
        },
        customerForm: {
            title: 'Ihre Daten',
            email: 'E-Mail-Adresse',
            name: 'Vollständiger Name',
            billingAddress: 'Rechnungsadresse',
            street: 'Straße und Hausnummer',
            city: 'Stadt',
            postalCode: 'Postleitzahl',
            country: 'Land',
        },
        summary: {
            title: 'Bestellübersicht',
            subtotal: 'Zwischensumme',
            discount: 'Rabatt',
            tax: 'MwSt.',
            total: 'Gesamtsumme',
        },
        payment: {
            title: 'Zahlungsmethode',
            paypal: 'Mit PayPal bezahlen',
            processing: 'Zahlung wird verarbeitet...',
        },
        confirmation: {
            title: 'Bestellung bestätigt!',
            thankYou: 'Vielen Dank für Ihre Bestellung!',
            orderNumber: 'Ihre Bestellnummer: %{orderNumber}',
            emailSent: 'Eine Bestätigungsmail wurde an %{email} gesendet.',
            viewOrders: 'Meine Bestellungen',
            continueShopping: 'Weiter einkaufen',
        },
        errors: {
            validationFailed: 'Bitte füllen Sie alle erforderlichen Felder aus.',
            paymentFailed: 'Zahlung fehlgeschlagen. Bitte versuchen Sie es erneut.',
            orderCreationFailed: 'Fehler beim Erstellen der Bestellung.',
        },
    },
};
